import {
  DECODE_ZIP,
  DECODE_ZIP_SUCCESS,
  DECODE_VIN,
  DECODE_VIN_SUCCESS,
  SUBMIT_FEES_FORM,
  SUBMIT_FEES_SUCCESS
} from './types';

export const decodeZip = (data) => (
  {
    type: DECODE_ZIP,
    payload: data,
  }
);

export const decodeZipSuccess = (data) => (
  {
    type: DECODE_ZIP_SUCCESS,
    payload: data,
  }
)

export const decodeVin = (data) => (
  {
    type: DECODE_VIN,
    payload: data,
  }
)

export const decodeVinSuccess = (data) => (
  {
    type: DECODE_VIN_SUCCESS,
    payload: data,
  }
)

export const submitFee = (data) => (
  {
    type: SUBMIT_FEES_FORM,
    payload: data,
  }
)

export const submitFeeSucess = (data) => (
  {
    type: SUBMIT_FEES_SUCCESS,
    payload: data,
  }
)
